import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["eventSelect", "newEventFields", "raceSelect", "newRaceFields"]

  connect() {
    this.update()
  }

  update() {
    if (this.hasNewEventFieldsTarget) {
      this.newEventFieldsTarget.classList.toggle("hidden", this.hasEventSelectTarget && this.eventSelectTarget.value !== "")
    }

    if (this.hasNewRaceFieldsTarget) {
      this.newRaceFieldsTarget.classList.toggle("hidden", this.hasRaceSelectTarget && this.raceSelectTarget.value !== "")
    }
  }
}
